const Enums = {
  TaskType: {
    Custom: 0,
    TaxReturn: 1,
  },
  ExpertTaxLanguage: {
    EN: 0,
    ES: 1,
  },
  DateFrequency: {
    Annual: 0,
    Quarterly: 1,
    Monthly: 2,
  },
  WeekdayBehavior: {
    AfterWeekend: 0,
    BeforeWeekend: 1,
  },
  FinancialYear: {
    CalendarYear: 0,
    FiscalYear: 1,
  },
  PermissionType: {
    User: 0,
    Group: 1,
  },
  DueDateYearCalculationTypes: {
    PeriodEnd: 0,
    PeriodStart: 1,
  },
  ViewType: {
    Custom: 0,
    AllTasks: 1,
    AssignedToMe: 2,
    OverdueTasks: 3,
    CompletedTasks: 4,
    RelatedToMe: 5,
    MyCompletedTasks: 6,
  },
  SortOrder: {
    Ascending: 0,
    Descending: 1,
  },
  StageType: {
    Todo: 0,
    InProgress: 1,
    Completed: 2,
  },
  FilingStatus: {
    Filed: 1,
    NotFiled: 2,
    WaitingResponse: 3,
    Error: 4,
  },
  AppRole: {
    Administrator: 1,
    Manager: 2,
    Staff: 3,
    DataEntry: 4,
  },
  ImportStatus: {
    Queued: 0,
    Processing: 1,
    Failed: 2,
    Success: 3,
  },
  EmailFrequency: {
    Weekly: 0,
    Monthly: 1,
  },
  NotifyMeAbout: {
    AllTasks: 0,
    MyTasks: 1,
    TasksRelatedToMe: 2,
  },
  CustomFieldDefinitionType: {
    Text: 0,
    Number: 1,
    Date: 2,
    Boolean: 3,
  },
};

const getKey = (object, value) => {
  return Object.keys(object)[value];
};

Enums.getKey = getKey;

export default Enums;
